module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.obj.isShow) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flashModel animated zoomIn"
  }, [_c('h4', [_vm._v("提示"), _c('i', {
    staticClass: "icon-guanbi2 fr",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-xuanze"
  }), _vm._v(" " + _vm._s(_vm.obj.content))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-60f67988"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tipsModel/tipsModel.vue
// module id = 835
// module chunks = 39